'use strict';
/* ===================================================================================== @preserve =
 ___  _   _    _
/   || | | |  | |
\__  | | | |  | |  __
/    |/  |/_) |/  /  \_/\/
\___/|__/| \_/|__/\__/  /\_/
              |\
              |/
Ajaxinate
version v2.0.4
https://github.com/Elkfox/Ajaxinate
Copyright (c) 2017 Elkfox Co Pty Ltd
https://elkfox.com
MIT License
================================================================================================= */

var Ajaxinate = function ajaxinateConstructor(config) {
  var settings = config || {};
  /*
    pagination: Selector of pagination container
    container: Selector of repeating content
    offset: 0, offset the number of pixels before the bottom to start loading more on scroll
    loadingText: 'Loading', The text changed during loading
    callback: null, function to callback after a new page is loaded
  */

  var defaultSettings = {
    method: 'scroll',
    container: '#AjaxinateContainer',
    pagination: '#AjaxinatePagination',
    offset: 0,
    loadingText: 'Loading',
    callback: null
  }; // Merge configs

  this.settings = Object.assign(defaultSettings, settings);
  this.destroyed = false;
  this.isLoading = false;
  this.addScrollListeners = this.addScrollListeners.bind(this);
  this.addClickListener = this.addClickListener.bind(this);
  this.checkIfPaginationInView = this.checkIfPaginationInView.bind(this);
  this.stopMultipleClicks = this.stopMultipleClicks.bind(this);
  this.removeClickListener = this.removeClickListener.bind(this);
  this.removeScrollListener = this.removeScrollListener.bind(this);
  this.destroy = this.destroy.bind(this);
  this.containerElement = document.querySelector(this.settings.container);
  this.paginationElement = document.querySelector(this.settings.pagination);
  this.initialize();
};

Ajaxinate.prototype.initialize = function initializeTheCorrectFunctionsBasedOnTheMethod() {
  if (this.containerElement && !this.destroyed && !this.isLoading) {
    var initializers = {
      click: this.addClickListener,
      scroll: this.addScrollListeners
    };
    initializers[this.settings.method]();
  }
};

Ajaxinate.prototype.addScrollListeners = function addEventListenersForScrolling() {
  if (this.paginationElement && !this.destroyed && !this.isLoading) {
    document.addEventListener('scroll', this.checkIfPaginationInView);
    window.addEventListener('resize', this.checkIfPaginationInView);
    window.addEventListener('orientationchange', this.checkIfPaginationInView);
  }
};

Ajaxinate.prototype.addClickListener = function addEventListenerForClicking() {
  if (this.paginationElement && !this.destroyed && !this.isLoading) {
    this.nextPageLinkElement = this.paginationElement.querySelector('a');
    this.clickActive = true;

    if (typeof this.nextPageLinkElement !== 'undefined' && this.nextPageLinkElement !== null) {
      this.nextPageLinkElement.addEventListener('click', this.stopMultipleClicks);
    }
  }
};

Ajaxinate.prototype.stopMultipleClicks = function handleClickEvent(event) {
  if (this.destroyed || event.defaultPrevented || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey ||
      (typeof event.button === 'number' && event.button !== 0)) {
    return;
  }
  event.preventDefault();

  if (this.clickActive) {
    this.originalLinkText = this.nextPageLinkElement.innerText;
    this.nextPageLinkElement.innerText = this.settings.loadingText;
    this.nextPageUrl = this.nextPageLinkElement.href;
    this.clickActive = false;
    this.loadMore();
  }
};

Ajaxinate.prototype.checkIfPaginationInView = function handleScrollEvent() {
  if (this.destroyed || this.isLoading || !this.paginationElement) return;
  var top = this.paginationElement.getBoundingClientRect().top - this.settings.offset;
  var bottom = this.paginationElement.getBoundingClientRect().bottom + this.settings.offset;

  if (top <= window.innerHeight && bottom >= 0) {
    this.nextPageLinkElement = this.paginationElement.querySelector('a');
    this.removeScrollListener();

    if (this.nextPageLinkElement) {
      this.originalLinkText = this.nextPageLinkElement.innerText;
      this.nextPageLinkElement.innerText = this.settings.loadingText;
      this.nextPageUrl = this.nextPageLinkElement.href;
      this.loadMore();
    }
  }
};

Ajaxinate.prototype.loadMore = function getTheHtmlOfTheNextPageWithAnAjaxRequest() {
  if (this.destroyed || this.isLoading) return;
  this.isLoading = true;
  var self = this;
  var request;
  var settled = false;
  var applying = false;

  function fallback() {
    if (settled || self.destroyed) return;
    settled = true;
    self.destroy();
  }

  try {
    request = this.request = new XMLHttpRequest();
    request.onerror = fallback;
    request.ontimeout = fallback;
    request.onabort = fallback;
    request.onreadystatechange = function success() {
      if (settled || applying || self.destroyed || self.request !== request || request.readyState !== 4) return;
      if (request.status !== 200) {
        fallback();
        return;
      }

      var response = request.responseXML;
      try {
        var newContainer = response && response.querySelectorAll(self.settings.container)[0];
        var newPagination = response && response.querySelectorAll(self.settings.pagination)[0];
        if (!newContainer || !newPagination || typeof newContainer.innerHTML !== 'string' ||
            typeof newPagination.innerHTML !== 'string' || self.containerElement.isConnected === false ||
            self.paginationElement.isConnected === false) {
          fallback();
          return;
        }
        applying = true;
        self.removeClickListener();
        self.containerElement.insertAdjacentHTML('beforeend', newContainer.innerHTML);
        self.paginationElement.innerHTML = newPagination.innerHTML;
      } catch (_error) {
        fallback();
        return;
      }

      settled = true;
      request.onreadystatechange = request.onerror = request.ontimeout = request.onabort = null;
      self.request = null;
      self.isLoading = false;
      self.originalLinkText = undefined;
      try {
        if (typeof self.settings.callback === 'function') self.settings.callback(response);
      } catch (_error) {
      }
      self.initialize();
    };

    request.open('GET', this.nextPageUrl);
    request.responseType = 'document';
    request.timeout = 15000;
    request.send();
  } catch (_error) {
    fallback();
  }
};

Ajaxinate.prototype.removeClickListener = function removeClickEventListener() {
  if (this.nextPageLinkElement) {
    this.nextPageLinkElement.removeEventListener('click', this.stopMultipleClicks);
  }
};

Ajaxinate.prototype.removeScrollListener = function removeScrollEventListener() {
  document.removeEventListener('scroll', this.checkIfPaginationInView);
  window.removeEventListener('resize', this.checkIfPaginationInView);
  window.removeEventListener('orientationchange', this.checkIfPaginationInView);
};

Ajaxinate.prototype.destroy = function removeEventListenersAndRemoveThis() {
  this.destroyed = true;
  this.clickActive = false;
  this.isLoading = false;
  this.removeClickListener();
  this.removeScrollListener();
  if (this.nextPageLinkElement && typeof this.originalLinkText === 'string') {
    this.nextPageLinkElement.innerText = this.originalLinkText;
  }
  if (this.request) {
    var request = this.request;
    this.request = null;
    request.onreadystatechange = request.onerror = request.ontimeout = request.onabort = null;
    try {
      request.abort();
    } catch (_error) {
    }
  }
  return this;
};


// Observe product grid instead of wrong container
const target = document.querySelector('#product-grid, .product-grid, .collection__main');
if (target) {
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === 1) {
          // Direct product-card bhi check karo
          if (node.matches && node.matches('product-card')) {
            applyReveal(node);
          }
          // And inside elements bhi check karo
          const cards = node.querySelectorAll('product-card[reveal-on-scroll="true"]');
          cards.forEach(applyReveal);
        }
      });
    });
  });
  observer.observe(target, {
    childList: true,
    subtree: true
  });
}

// Function to apply animation
function applyReveal(el) {
  el.style.opacity = "1";
  el.style.transform = "translateY(0px)";
}
